import { render } from "./PersonalDetails.vue?vue&type=template&id=b5d91814&scoped=true&lang=pug"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts"

import "./PersonalDetails.vue?vue&type=style&index=0&id=b5d91814&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b5d91814"

export default script